/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Org_NameInputs */

const cs_auth_signup_org_name = /** @type {(inputs: Auth_Signup_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název kanceláře (nebo vaše jméno)`)
};

const en_auth_signup_org_name = /** @type {(inputs: Auth_Signup_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office name (or your name)`)
};

/**
* | output |
* | --- |
* | "Office name (or your name)" |
*
* @param {Auth_Signup_Org_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_org_name = /** @type {((inputs?: Auth_Signup_Org_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Org_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_org_name(inputs)
	return cs_auth_signup_org_name(inputs)
});